import PageIndex from './src/index-material';
export default PageIndex;